var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIconSurprised = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.2002,
    cy: 16,
    r: 15.4074,
    fill: "#FFA1FB",
    stroke: "white",
    strokeWidth: 1.18519
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2002 6.91357C11.1908 6.91357 7.11377 10.9906 7.11377 16C7.11377 21.0094 11.1908 25.0864 16.2002 25.0864C21.2096 25.0864 25.2866 21.0094 25.2866 16C25.2866 10.9906 21.2096 6.91357 16.2002 6.91357Z",
    stroke: "#7C2379",
    strokeWidth: 1.18519,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2002 22.6805C14.6634 22.6805 13.415 21.4321 13.415 19.8953C13.415 18.3585 14.6634 17.1101 16.2002 17.1101C17.737 17.1101 18.9854 18.3585 18.9854 19.8953C18.9854 21.4321 17.737 22.6805 16.2002 22.6805Z",
    stroke: "#7C2379",
    strokeWidth: 1.18519,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7232 13.9339C13.7232 14.6173 13.1661 15.1743 12.4827 15.1743C11.7992 15.1743 11.2422 14.6213 11.2422 13.9339C11.2422 13.2464 11.7992 12.6934 12.4827 12.6934C13.1661 12.6934 13.7232 13.2504 13.7232 13.9339Z",
    fill: "#7C2379"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1582 13.9339C21.1582 14.6173 20.6012 15.1743 19.9177 15.1743C19.2343 15.1743 18.6772 14.6213 18.6772 13.9339C18.6772 13.2464 19.2343 12.6934 19.9177 12.6934C20.6012 12.6934 21.1582 13.2504 21.1582 13.9339Z",
    fill: "#7C2379"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconSurprised, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/iconSurprised.d60e2a78.svg";
export { ForwardRef as ReactComponent };